import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import ExploreProjects from "./components/ExploreProjects";
import GallaryPage from "./pages/GallaryPage";

function Routing() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/gallary" element={<GallaryPage />} />
        <Route path="/project/:id" element={<ExploreProjects />} />
      </Routes>
    </div>
  );
}

export default Routing;
